export const CURRENT_CONFIG = {

  // license
  appId: '162967', // 'Please enter the app id.', // You need to go to the development website to apply.
  appKey: '4a3c84c349ba3e8b0019cfaab675252', // 'Please enter the app key.', // You need to go to the development website to apply.
  appLicense: 'YzFZxv6SAPFBpEaJk66HP9wkb9Kg+tHIX3UErB7d9fWheNe4dfvpCAB95lJgDIpOh2vneMFBEjh0sGTMDurSFfkrf/WhuXTUmITqzzmLFoKInysmhYtQppxpDZcVPq67cIplfWfHklYJVXtZ5U2w2XBQBFCKuAQMFEFsGy293YI=', // 'Please enter the app license.', // You need to go to the development website to apply.

  // http
  baseURL: '/', //'http://drones.qa.aigis.io:6789/', // 'Please enter the backend access address prefix.', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/api/v1/ws`, //'ws://drones.qa.aigis.io:6789/api/v1/ws', // 'Please enter the WebSocket access address.', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://www.nideport.xyz/hls/', // 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
